import type { ReactNode } from 'react';
import { cx } from '../cx';
import { VALUE_TEXT, percentOf } from './scale';

export type BarCellProps = {
  value: number;
  /** The column's shared maximum: every BarCell in a column uses the same one. */
  max: number;
  display: ReactNode;
  className?: string;
};

/**
 * A bar inside a table cell, with its value: exact values and their shape at once. Use it in a
 * Table column (every row sharing `max`), next to a Sparkline column for an 8-week trend.
 */
export function BarCell({ value, max, display, className }: BarCellProps) {
  return (
    <span className={cx('flex min-w-24 items-center gap-2', className)}>
      <span className="h-2.5 flex-1">
        <span className="block h-full rounded-jc-info bg-jc-ink" style={{ width: `${percentOf(value, 0, max)}%` }} />
      </span>
      <span className={cx('w-10 shrink-0', VALUE_TEXT)}>{display}</span>
    </span>
  );
}
